<template>
  <base-page-layout :title="$getLoggedUser().client" class="home pa-7">
    <template v-if="$getIsEcommerce() && this.$getLoggedUser().ecommerce_url.length && !isMobile" v-slot:card-extra>
      <v-row justify="end" class="mt-n5">
        <v-col cols="auto">
          <ecommerce-card></ecommerce-card>
        </v-col>
      </v-row>
    </template>

    <v-row v-if="$getIsEcommerce() && this.$getLoggedUser().ecommerce_url.length && !$getIsClub()">
      <v-col cols="12">
        <cbm-opportunity-card></cbm-opportunity-card>
      </v-col>
    </v-row>

    <div v-if="isHomePermission">
      <div>
        <v-row>
          <v-col cols="12" class="pb-2"
            ><h2 class="date-subtitle">{{ currentDate }}</h2></v-col
          >
          <div v-if="isMobile">
            <mf-info-card class="mb-5" description="A visualização completa desta página está disponível apenas para computadores" />
          </div>
          <v-col lg="9" cols="12" class="py-0">
            <v-row class="card-group">
              <v-col cols="12" class="py-0">
                <minified-carrousel :loading="loading" :data="allData" />
              </v-col>
            </v-row>
            <v-row class="pt-3">
              <v-col lg="6" cols="12" class="py-0">
                <cbm-card
                  v-if="loading || hasDreOffersSchedulesResults || !showClubRevenue"
                  use-loader
                  :boolean-loader="loading"
                  :simple-card="false"
                  title="Faturamento incremental clube"
                  :show-blur="!showClubRevenue"
                  :blur-caption="blurCaption"
                  :blur-icon="blurIcon"
                >
                  <template v-slot:additional>
                    <div class="club-revenue-container">
                      <incremental-revenue-chart :show-mock-data="!showClubRevenue" variant="home" :analysed-period="analysedPeriod" />
                      <incremental-revenue-chart-metrics :show-mock-data="!showClubRevenue" variant="home" @go-to-dre="goToDre" />
                    </div>
                  </template>
                </cbm-card>
                <incremental-revenue-empty-state v-else />
              </v-col>

              <v-col v-if="!isMobile" lg="6" cols="12" class="py-0">
                <consumers-distribution-card
                  :loading="loading"
                  variant="home"
                  :analysed-period="consumersDistributionPeriod"
                  :analysis-initial-date="consumersDistributionInitialDate"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="!isMobile" lg="3" cols="12" class="py-0">
            <opportunities-card
              :have-permission="boostProductsPermission"
              :have-available-opportunities="haveAvailableOpportunities"
              :opportunities="opportunities"
              :loader="opportunitiesLoader"
              :boolean-loader="loading"
            />
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- <binds /> -->
  </base-page-layout>
</template>

<script>
import Vue from 'vue'
import capitalize from 'lodash/capitalize'
import { mapGetters, mapState, mapActions } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { DateTime } from 'luxon'

import BasePageLayout from '@/components/BasePageLayout.vue'
import CbmCard from '@/components/CbmCard.vue'
import OpportunitiesCard from '../components/OpportunitiesCard.vue'
import MinifiedCarrousel from '../components/MinifiedCarrousel.vue'
import { localeString, abbreviation } from '@/config/helpers.js'
import { fetchDataWithCache } from '@/helpers/cacheHelper'
import EcommerceCard from '../components/EcommerceCard.vue'
import CbmOpportunityCard from '../components/CbmOpportunityCard.vue'
import IncrementalRevenueChartMetrics from '@/modules/empresa/dre/views/components/incremental-revenue/IncrementalRevenueChartMetrics.vue'
import IncrementalRevenueChart from '@/modules/empresa/dre/views/components/incremental-revenue/IncrementalRevenueChart.vue'
import ConsumersDistributionCard from '@/modules/empresa/dre/views/components/consumers-distribution/ConsumersDistributionCard.vue'
import IncrementalRevenueEmptyState from '../components/IncrementalRevenueEmptyState.vue'
// import Binds from '@/plugins/binds/Binds.vue'

export default {
  components: {
    BasePageLayout,
    OpportunitiesCard,
    CbmCard,
    EcommerceCard,
    CbmOpportunityCard,
    IncrementalRevenueChartMetrics,
    IncrementalRevenueChart,
    MinifiedCarrousel,
    ConsumersDistributionCard,
    IncrementalRevenueEmptyState,
    // Binds,
  },
  data: () => ({
    loading: false,
    loadingEcommerceButton: false,
    capitalize: capitalize,
    haveAvailableOpportunities: true,
    lastYearCoupons: 0,
    lastMonthRevenue: 0,
    opportunitiesLoader: [
      'cupons-percentage',
      'percentual-faturamento',
      'faturamento',
      'cupons',
      'cuponsLastYear',
      'faturamento-dta',
      'percentual-faturamento-fidelidade',
      'media-compras-fidelidade-mes-anterior',
      'gasto-medio-fidelidade-mes-anterior',
      'opportunities-data',
    ],
  }),
  computed: {
    ...mapState({
      lastUpdate: (state) => state.lastUpdate,
      stateFilters: (state) => state.filters,
    }),
    ...mapGetters({
      anoAnterior: 'anoAnterior',
      faturamento: 'homeFaturamento',
      cupons: 'homeCupons',
      faturamentoDta: 'homeFaturamentoDta',
      faturamentoAnterior: 'homeFaturamentoAnterior',
      ticketMedio: 'homeTicketMedio',
      ticketMedioForaClube: 'homeTicketMedioForaClube',
      percentualFaturamentoFidelidade: 'homePercentualFaturamentoFidelidade',
      ticketMedioFidelidade: 'homeTicketMedioFidelidade',
      percentualTicketMedioFidelidade: 'homePercentualTicketMedioFidelidade',
      gastoMedioFidelidade: 'homeGastoMedioFidelidade',
      mediaComprasFidelidade: 'homeMediaComprasFidelidade',
      opportunities: 'homeOpportunities',
      units: 'units',
      analyticsConfiguration: 'analyticsConfiguration',
      analyticAllPeriods: 'analyticAllPeriods',
      hasDreOffersSchedulesResults: 'hasDreOffersSchedulesResults',
    }),
    isBackoffice() {
      return this.$getLoggedUser()?.integrationType === 'backoffice'
    },
    blurCaption() {
      return this.isBackoffice ? 'Integração incompatível com o PDV' : 'Sem permissão de acesso'
    },
    blurIcon() {
      return this.isBackoffice ? 'lightbulb' : 'lock'
    },
    showClubRevenue() {
      return this.$permissions.havePagePermission('empresa/faturamento_incremental') && this.$getAllowedModules()['offer_management'] && !this.isBackoffice
    },
    boostProductsPermission() {
      return this.$permissions.havePagePermission('maria/produtos-impulsionadores')
    },
    onlyMercapromo() {
      return this.$getLoggedUser().only_mercapromo
    },
    filter() {
      const lastUpdated = this.lastUpdate?.last_updated?.toString() || ''
      return {
        date: [DateTime.fromFormat(lastUpdated, 'yyyyMMdd').toFormat('yyyy-MM')],
        club: [DateTime.fromFormat(lastUpdated, 'yyyyMMdd').toFormat('yyyy-MM-01'), DateTime.fromFormat(lastUpdated, 'yyyyMMdd').toFormat('yyyy-MM-dd')],
      }
    },
    allData() {
      const couponsValue = this.lastYearCoupons ? this.lastYearCoupons : 0
      const couponsPercentage = this.lastYearCoupons ? localeString(100 - (this.lastYearCoupons * 100) / this.cupons, 1) : 0
      const revenuePercentage = this.lastMonthRevenue[0]
        ? localeString(this.percentualFaturamentoFidelidade - this.lastMonthRevenue[0].PER_FATURAMENTO_FIDELIDADE, 1)
        : 0

      return [
        {
          title: 'Média de cupons - Clube',
          value: localeString(this.mediaComprasFidelidade || 0, 2),
          percentageTooltip: null,
          currency: false,
          percentage: false,
          showExtra: false,
        },
        {
          title: 'Gasto médio - Clube',
          value: localeString(this.gastoMedioFidelidade || 0, 2),
          percentageTooltip: null,
          currency: true,
          percentage: false,
          showExtra: false,
        },
        {
          title: 'Faturamento',
          value: localeString(this.faturamento || 0, 0),
          tooltip: `Faturamento do mês de ${this.lastYear} até essa data: R$${localeString(this.faturamentoAnterior)}`,
          currency: true,
          percentage: false,
          extra: localeString(this.faturamentoDta, 1),
          showExtra: true,
          extraType: 'year',
        },
        {
          title: 'Cupons',
          value: localeString(this.cupons || 0, 0),
          tooltip: `Cupons do mês de ${this.lastYear} até essa data: ${localeString(couponsValue)}`,
          currency: false,
          percentage: false,
          extra: couponsPercentage,
          showExtra: true,
          extraType: 'year',
        },
        {
          title: 'Faturamento identificado',
          value: localeString(this.percentualFaturamentoFidelidade || 0, 1),
          tooltip: `Faturamento identificado do mês de ${this.lastMonthDate}: ${
            this.lastMonthRevenue[0] ? abbreviation(this.lastMonthRevenue[0].PER_FATURAMENTO_FIDELIDADE, { isCurrency: true }) : '0'
          }%`,
          currency: false,
          percentage: true,
          extra: revenuePercentage,
          showExtra: true,
          extraType: 'month',
        },
        {
          title: 'Ticket médio - Geral',
          value: localeString(this.ticketMedio || 0, 2),
          percentageTooltip: null,
          currency: true,
          percentage: false,
          extra: null,
          showExtra: false,
          extraType: null,
        },
        {
          title: 'Ticket médio - Clube',
          value: localeString(this.ticketMedioFidelidade || 0, 2),
          percentageTooltip: null,
          currency: true,
          percentage: false,
          extra: localeString(this.percentualTicketMedioFidelidade || 0, 1),
          showExtra: true,
          extraType: 'club',
        },
        {
          title: 'Ticket médio - Fora clube',
          value: localeString(this.ticketMedioForaClube || 0, 2),
          percentageTooltip: null,
          currency: true,
          percentage: false,
          extra: null,
          showExtra: false,
          extraType: null,
        },
      ]
    },
    lastUpdateDateTime() {
      if (!this.lastUpdate.last_updated) return null
      return DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd')
    },
    lastYear() {
      return this.lastUpdateDateTime ? this.lastUpdateDateTime.minus({ year: 1 }).endOf('month').toFormat("MMMM 'de' yyyy") : ''
    },
    lastMonthDate() {
      return this.lastUpdateDateTime ? this.lastUpdateDateTime.minus({ months: 1 }).endOf('month').toFormat("MMMM 'de' yyyy") : ''
    },
    analysedPeriod() {
      if (!this.lastUpdateDateTime) return ''
      return this.lastUpdateDateTime.toFormat('yyyy-MM').toString()
    },
    currentDate() {
      if (!this.lastUpdateDateTime) return ''
      const formattedDate = this.lastUpdateDateTime.toFormat("MMMM 'de' yyyy").toString()
      return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
    },
    consumersDistributionPeriod() {
      if (!this.lastUpdateDateTime) return ['', '']
      const initialDate = this.lastUpdateDateTime.minus({ days: 30 }).toFormat('yyyyMMdd')
      return [initialDate, this.lastUpdateDateTime.toFormat('yyyyMMdd')]
    },
    consumersDistributionInitialDate() {
      if (!this.lastUpdateDateTime) return ''
      return this.lastUpdateDateTime.toFormat('yyyyMMdd')
    },
    isHomePermission() {
      return this.$getIsClub() && this.$permissions.havePagePermission('home')
    },
  },
  async beforeMount() {
    try {
      this.loading = true
      await this.$store.dispatch('getStates', ['getLastUpdate'])
      const lastUpdate = this.lastUpdateDateTime ? this.lastUpdateDateTime.toFormat('yyyy-MM-dd').toString() : ''

      await this.getHomeConsumersDistribution(lastUpdate)
      await this.getAnalyticsConfiguration({ type: 'DRE', useCache: true })
      await this.getAllAnalyticPeriods({ analyticConfigurationsIds: this.analyticsConfiguration?._id, useCache: true })

      const lastUpdateYearMonth = this.lastUpdateDateTime.toFormat('yyyy-MM')
      const lastUpdatePeriod = this.analyticAllPeriods.find(
        (period) => DateTime.fromFormat(period.initialDate, 'yyyy-MM-dd').toFormat('yyyy-MM') === lastUpdateYearMonth
      )

      const lastUpdatedMinusThiryDays = this.lastUpdateDateTime.minus({ months: 1 }).toFormat('yyyy-MM-dd')
      const analysedPeriodId = lastUpdatePeriod?._id
      const input = {
        input: {
          analyticConfigurationId: this.analyticsConfiguration?._id,
          periodId: analysedPeriodId,
        },
        useCache: true,
      }

      const homeFunctions = [
        this.homeFaturamento(this.filter),
        this.homeCupons(this.filter),
        this.homeFaturamentoDta(this.filter),
        this.homeTicketMedio(this.filter),
        this.homePercentualFaturamentoFidelidade(this.filter),
        this.homeTicketMedioFidelidade(this.filter),
        this.homeTicketMedioForaClube(this.filter),
        this.homePercentualTicketMedioFidelidade(this.filter),
        this.homeGastoMedioFidelidade(this.filter),
        this.homeMediaComprasFidelidade(this.filter),
        this.getDreRevenueIncrementMetrics(input),
        this.getDreClientsDistributionBefore(input),
        this.getDreOffersSchedulesResult(input),
        this.homeTotalClientesCadastrados(),
        this.homeClientesCadastrados({ date: [lastUpdatedMinusThiryDays, lastUpdate] }),
      ]
      await Promise.all(homeFunctions)
      await this.getCompanyCoupons()
      await this.getClubRevenue()
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }
  },
  async mounted() {
    if (this.boostProductsPermission) {
      await this.getOpportunities()
      if (
        this.opportunities.revenuePercentage * 100 < 1 ||
        this.opportunities.clientsPercentage * 100 < 1 ||
        this.opportunities.basketItemsPercentage * 100 < 1
      ) {
        this.haveAvailableOpportunities = false
      }
    }
  },
  methods: {
    ...mapWaitingActions({
      empresaCupons: 'cupons-percentage',
      clubePercentualFaturamentoFidelidade: 'percentual-faturamento',
      homeFaturamento: 'faturamento',
      homeCupons: 'cupons',
      homeFaturamentoDta: 'faturamento-dta',
      homeTicketMedio: 'ticket-medio',
      homePercentualFaturamentoFidelidade: 'percentual-faturamento-fidelidade',
      homeTicketMedioFidelidade: 'ticket-medio-fidelidade',
      homeTicketMedioForaClube: 'ticket-medio-fora-clube',
      homePercentualTicketMedioFidelidade: 'percentual-ticket-medio-fidelidade',
      homeMediaComprasFidelidade: 'media-compras-fidelidade',
      homeGastoMedioFidelidade: 'gasto-medio-fidelidade',
      getSuggestedProductsOpportunities: 'opportunities-data',
    }),
    ...mapActions([
      'getSuggestedProductsOpportunities',
      'getDreRevenueIncrementMetrics',
      'getDreClientsDistributionBefore',
      'getAnalyticsConfiguration',
      'getAllAnalyticPeriods',
      'getHomeConsumersDistribution',
      'homeTotalClientesCadastrados',
      'homeClientesCadastrados',
      'getDreOffersSchedulesResult',
    ]),
    goToDre() {
      this.$router.push('/empresa/faturamento-incremental')
    },

    async getCompanyCoupons() {
      const lastUpdated = this.lastUpdate?.last_updated?.toString() || ''

      const fetchFunction = async () => {
        const response = await this.empresaCupons({
          date: [
            DateTime.fromFormat(lastUpdated, 'yyyyMMdd').minus({ year: 1 }).toFormat('yyyy-MM-01'),
            DateTime.fromFormat(lastUpdated, 'yyyyMMdd').minus({ year: 1 }).toFormat('yyyy-MM-dd'),
          ],
        })
        return response
      }

      const data = await fetchDataWithCache('getCompanyCoupons', fetchFunction, this.lastUpdate?.last_updated, this.lastUpdate?.processing_uuid)

      this.lastYearCoupons = data?.NUM_CUPONS
    },

    async getClubRevenue() {
      const fetchFunction = async () => {
        const response = await this.clubePercentualFaturamentoFidelidade({ group_field: 'ano,mes', filtro: { fidelidade: 1 } })
        return response
      }

      const data = await fetchDataWithCache('getClubRevenue', fetchFunction, this.lastUpdate?.last_updated, this.lastUpdate?.processing_uuid)

      const lastMonthDate = this.lastUpdateDateTime.minus({ months: 1 })
      const month = lastMonthDate.get('month')
      const year = lastMonthDate.get('year')

      this.lastMonthRevenue = data.filter((item) => item.NUM_ANO === year && item.NUM_MES === month)
    },
    async getOpportunities() {
      const allUnits = this.units.map((unit) => unit.id_erp)
      try {
        const variables = { units: allUnits }
        await this.getSuggestedProductsOpportunities(variables)
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao buscar oportunidades.', snackbarColor: 'error' })
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (Vue.getFirstValue()) next({ path: '/primeiro-valor' })
    else next()
  },
}
</script>

<style lang="scss" scoped>
.home {
  .date-subtitle {
    color: $cinza-l20;
    font-weight: 400;
    font-size: 18px;
    line-height: 21.6px;
    margin-bottom: 0;
  }
  .card-title {
    padding-bottom: 7px;
    padding-left: 1px;
    padding-top: 15px;
    font-size: 18.5px;
  }
}
.clients-card-data {
  padding: 2px 0 2px 0;
  .number {
    font-size: 16px;
    font-weight: 700;
    line-height: 120%;
  }
  .label {
    color: $cinza-0;
    font-size: 14px;
    margin-left: 3px;
  }
}

.club-revenue-container {
  display: flex;
  align-items: flex-start;
  gap: 32px;
  width: 100%;
  height: 100%;
}
</style>
